export default {"src":"/_next/static/media/quiz-almost-done.e5cfc517.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};